import { useEffect, useRef } from "react";

// Kit (ConvertKit) inline signup form — public embed, no API key.
const KIT_FORM_SRC = "https://tattooed-abroad.kit.com/47acc3a27d/index.js";
const KIT_FORM_UID = "47acc3a27d";

export const KitInlineForm = ({ className = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Idempotent across hot reload / Strict Mode remounts.
    container.replaceChildren();

    const script = document.createElement("script");
    script.async = true;
    script.dataset.uid = KIT_FORM_UID;
    script.src = KIT_FORM_SRC;

    // Kit's embed script renders the form relative to this script element,
    // so it must live inside this instance's own container.
    container.appendChild(script);

    return () => {
      container.replaceChildren();
    };
  }, []);

  return <div ref={containerRef} className={`w-full ${className}`} aria-live="polite" />;
};
